<template>

    <!-- Begin page -->
    <div id="wrapper">

        <!-- Top Bar Start -->
        <topbar></topbar>
        <!-- Top Bar End -->


        <!-- ========== Left Sidebar Start ========== -->

        <!-- Left Sidebar End -->
        <left></left>


        <!-- ============================================================== -->
        <!-- Start right Content here -->
        <!-- ============================================================== -->
        <div class="content-page">
            <!-- Start content -->
            <div class="content">
                <div class="container-fluid">

                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title float-left">考试专区</h4>
                                <ol class="breadcrumb float-right">
                                    <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                    <li class="breadcrumb-item"><a href="#">考试专区</a></li>
                                    <li class="breadcrumb-item active">考试报名</li>
                                </ol>

                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                    <!-- end row -->


                    <div class="row">
                        <div class="col-12">
                            <div class="card-box">
                                <p class="text-muted m-b-30 font-14">
                                <div class="look1">点击查看</div>
                                <div class="look2">
                                    <a href="2.pdf" target="_blank">《特许私人财富管理师（CPWM）认证考试考生违纪行为认定及处理办法》</a><br/>
                                    <a href="https://dadandao.oss-cn-beijing.aliyuncs.com/uploads/1/%E7%89%B9%E8%AE%B8%E7%A7%81%E4%BA%BA%E8%B4%A2%E5%AF%8C%E7%AE%A1%E7%90%86%E5%B8%88CPWM%C2%AE%E8%AE%A4%E8%AF%81%E8%80%83%E8%AF%95%E9%A2%84%E7%BA%A6%E6%8C%87%E5%BC%95.pdf"
                                       target="_blank">《特许私人财富管理师CPWM<sup>&#174;</sup>认证考试预约指引》</a>

                                </div>
                                </p>
                                <div class="row" style="float: left;">
                                    <div class="col-12">
                                        <div class="p-20">
                                            <div class="tiaokuan">
                                                <h2>--报考协议条款--</h2>
                                                <p>1、考生须仔细阅读《考生违纪行为认定及处理办法》,并照此规定遵守考试纪律。</p>
                                                <p>
                                                    2、对于雷同结果，考试主办方有权请雷同作答的考生再次参加考试，再次考试的考试时间、考试内容、考试形式及考试结果的判定由考试主办方决定并具有最终裁定权。</p>
                                                <p>
                                                    3、考试主办方有权对监控过程中有可疑作弊行为且通过考试的考生进行重点复核，保留要求其再次参加考试的权利，其考试时间、考试内容、考试形式及考试结果的判定由考试主办方决定并具有最终裁定权。</p>
                                                <p>
                                                    4、考试主办方仅会出于注册考试、安排考试日程、管理考试以及处理考试成绩的目的来处理您的个人信息。未经您的许可，考试主办方绝不会将您的个人信息用于任何其他目的。考试中心网络中已部署数字视频录制系统（DVR
                                                    或
                                                    CCTV）。在适用法律允许的情况下，这包括在接待室/寄存间、监考区/安全登记处和考试实验室区域内安装音频录制系统。为了保护高风险专项考试内容的安全性、考试交付体验的完整性，阻止欺诈和欺骗，防止盗窃和偷盗，以及为了员工和公司财产的安全，这样做很有必要。录制的材料将严格限于授权人员接触，并按照当地适用法律允许的期限保留。</p>
                                                <p>
                                                    5、由于地震、台风、火（水）灾、战争、停电、断电、网络信号中断、考试硬件设备意外损坏等无法预见、无法避免的不可抗力因素引起的考试中断或取消，考试中心将为考生免费安排下次考试机会。请在考前24~48小时关注邮件及手机，以便发生影响考试安排的情况时。考试主办方对考生因上述不可抗力事件造成的损失不承担任何责任，包括但不限于不予退还考试费用等。</p>
                                                <p>6、报名预约等应由考生自己填报，考生委托他人代替填报造成的一切后果由考生本人承担相关责任。
                                                    考生的姓名、密码、手机号、邮箱、邮寄地址等信息，请注意保密。由于考生个人原因造成的因密码等个人信息泄露而造成的损失，由考生自行承担。</p>

                                            </div>
                                            <div class="form-group">
                                                <div class="form-check">
                                                    <label class="form-check-label">
                                                        <input class="form-check-input" type="checkbox"
                                                               v-model="checkedyouknow">
                                                        <span>我已经阅读并认可《报考协议条款》</span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div style="width: 100%;float:left;padding:20px;text-align: center;"
                                                 v-if="status">
                                                <button type="submit" style="margin: 0 auto;"
                                                        class="btn btn-gradient btn-rounded waves-light waves-effect w-md"
                                                        v-on:click="baoming">下一步
                                                </button>
                                            </div>
                                            <div style="clear: both"></div>


                                        </div>
                                    </div>

                                </div>
                                <!-- end row -->
                                <div style="clear: both"></div>
                            </div> <!-- end card-box -->
                        </div><!-- end col -->
                    </div>
                    <!-- end row -->


                </div> <!-- container -->

            </div> <!-- content -->

            <!--footer-->

        </div>


        <!-- ============================================================== -->
        <!-- End Right content here -->
        <!-- ============================================================== -->


    </div>
    <!-- END wrapper -->


</template>

<script>
import topbar from './topbar';
import left from './left';

export default {
    name: 'signup',
    components: {topbar, left},
    data() {
        return {
            paynum: false,
            status: this.status,
        }
    },
    mounted() {
        this.showmember();
        //console.log(this.status)
    },
    methods: {
        baoming: function () {
            let checkedyouknow = this.checkedyouknow;
            if (!checkedyouknow) {
                alert('必须勾选并同意 报考须知！');
                return false;
            } else {
                //this.$router.push({name:'signup_check'});
                if (this.paynum == true) {
                    this.$router.push({name: 'signup_code'});
                } else {
                    this.$router.push({name: 'signup_pay'});
                }

            }

        },
        showmember: function () {

            this.$axios({
                method: 'get',
                url: '/api/member2/member_show',
                headers: {
                    membertoken: localStorage.getItem('membertoken')
                }
            }).then(function OnSuccess(response) {
                this.status = response.data.other.status;
                //this.status = response.data.other.examination_status;
                //console.log(response.data.other.status);
                //console.log("----")
                //console.log(response.data.other)
                //console.log(response.data.other.examination_status)
                if (response.data.other.status == 1) {
                    swal(
                        {
                            title: response.data.other.msg,
                            text: '',
                            type: 'error',
                            confirmButtonColor: '#4fa7f3',
                        }
                    ).then(function () {
                        window.location.href = "/member2/#/main";
                    })

                } else if (response.data.other.status == 2) {
                    console.log('本期考试，当前学员已经生成资格码');
                    this.$router.push({name: 'signup_code'});
                } else if (response.data.other.status == 3) {
                    //当前考试该学员没有报名信息，并且没有免费报名次数,显示当前页面
                    this.paynum = false
                } else if (response.data.other.status == 4) {
                    console.log('当前考试该学员没有报名信息，有免费报名次数，可以免费报名');
                    this.paynum = true
                    // this.$router.push({name:'signup_code'});
                } else if (response.data.other.status == 5) {
                    console.log('无法认证，已经超过两年期限');
                    window.location.href = "/member2/#/Authentication_show?key=5";
                    //this.$router.push({name:'signup_code'});
                    /*
                    swal(
                          {
                                title: '特许私人财富管理师（CPWM<sup>&#174;</sup>）培训合格的有效期为2年。您已超过2年有效期，请重新参加授权机构的培训。',
                                text: '',
                                type: 'error',
                                confirmButtonColor: '#4fa7f3',
                          }
                    ).then(function () {
                          window.location.href="/member2/#/main";
                    })
                     */
                } else if (response.data.other.status == 6) {
                    //(当前考试不及格)当前考试该学员没有报名信息，并且没有免费报名次数
                } else if (response.data.other.status == 7) {
                    console.log('(当前考试不及格)当前考试该学员没有报名信息，有免费报名次数，可以免费报名');
                    //this.$router.push({name:'signup_code'});
                    this.paynum = true
                } else if (response.data.other.status == 8) {
                    console.log('(考试已经通过，请前往认证');
                    this.$axios({
                        method: 'get',
                        url: '/api/member2/Authentication_status',
                        headers: {
                            membertoken: localStorage.getItem('membertoken')
                        }
                    }).then(function OnSuccess(response) {

                        if (response.data.code == 1 && response.data.msg == 10) {
                            window.location.href = '#/Authentication_show?key=11';
                        } else if (response.data.code == 1 && (response.data.msg == 14 || response.data.msg == 15)) {
                            window.location.href = '#/Authentication_show?key=15';
                        } else {
                            swal(
                                {
                                    title: '您已通过特许私人财富管理师（CPWM<sup>&#174;</sup>）认证考试，考试结果有效期为2年（有效期开始日期为考试通过日期）。',
                                    text: '',
                                    type: 'success',
                                    confirmButtonColor: '#4fa7f3',
                                }
                            ).then(function () {
                                window.location.href = "/member2/#/Authentication";
                            })
                        }

                    }.bind(this)).catch(function OnError() {

                    })


                }
            }.bind(this)).catch(function OnError() {

            })

        },

        //method over

    }
    //mounted over


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.zx {
    width: 100%;
}

.zx li {
    width: 100%;
    float: left
}

.look1 {
    width: 5%;
    float: left
}

.look2 {
    width: 95%;
    float: left
}

.tiaokuan {
    width: 100%;
    border: 1px dashed #333333;
    border-radius: 20px;
    padding: 30px;
    margin: 30px 0;
    margin-bottom: 20px;
}

.tiaokuan h2 {
    width: 100%;
    text-align: center;
    font-size: 18px;
}

.tiaokuan p {
    width: 100%;
    font-size: 14px;
    line-height: 28px;
}


</style>



// WEBPACK FOOTER //
// src/components/signup.vue